<template>
    <v-row>
        <v-col cols='12'>
            <InfoAlert>
                <ul class='pl-0 pr-4'>
                    <li>قوانین مجموعه، توسط مدیر مجموعه با مشارکت ساکنین نوشته میشود و تایید قوانین برای تمامی ساکنین
                        الزامی میباشد.
                    </li>
                    <li>برای تعريف قوانین مجموعه، میتوانید قوانین عمومی از پیش تعریف شده را انتخاب کنید و همچنین قوانین
                        مخصوص به مجموعه خود را به آن اضافه کنید و یا موردی از قوانین را اصلاح کنید.
                    </li>
                </ul>
                <template slot='action'>
                    <v-btn
                        small
                        color='primary'
                        outlined
                        @click='toggleDialog'
                    >
                        قوانین از پیش تعریف شده
                    </v-btn>

                    <v-dialog
                        v-model='rulesTemplateDialog'
                        @close='toggleDialog(false)'
                        @click:outside='toggleDialog(false)'
                        scrollable
                    >
                        <v-card outlined>
                            <v-card-title class='subtitle-1'>انتخاب نمونه قوانین مجموعه</v-card-title>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row class='rule-template-list'>
                                        <v-col cols='12'>
                                            <v-list class='py-0'>
                                                <v-list-item-group multiple active-class=''>
                                                    <v-checkbox
                                                        v-for='item in rule_templates'
                                                        :key='item._id'
                                                        class='item rtl'
                                                        v-model='selectedRuleItems'
                                                        :label='item.text'
                                                        :value='item.text'
                                                        hide-details
                                                    ></v-checkbox>
                                                </v-list-item-group>
                                            </v-list>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    color='primary'
                                    block
                                    @click='useSelectedItem'
                                >
                                    انتخاب
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </template>
            </InfoAlert>
        </v-col>
        <!--Rules-->
        <v-col cols='12'>
            <vue-editor
                :editorToolbar='toolbar'
                v-model='apartment.rules'
                placeholder='متن'
                :use-custom-image-handler='true'
            ></vue-editor>
        </v-col>
        <v-col cols='12'>
            <v-card-actions class='pa-0'>
                <v-btn
                    outlined
                    @click='goToStep(step-1)'
                >
                    مرحله قبل
                </v-btn>
                <v-spacer/>
                <v-btn
                    :loading='loadingSubmitApartmentRules'
                    :disabled='loadingSubmitApartmentRules'
                    color='primary'
                    @click='submitApartmentRules'
                >ثبت
                </v-btn>
            </v-card-actions>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";
import {createSupportRequest} from "@/plugins/createSupportRequest";
import {VueEditor} from "vue2-editor";
import InfoAlert from "@/components/Alerts/InfoAlert";

export default {
    name: "defineRules",
    components: {
        InfoAlert,
        VueEditor,
    },
    props: {
        apartment: Object,
        goToStep: Function,
        step: Number,
        supportRequest_id: String
    },
    model: {
        prop: 'apartment',
        event: 'updateApartment'
    },
    data() {
        return {
            rulesTemplateDialog: false,
            rule_templates: [],
            selectedRuleItems: [],
            loadingFetchRuleTemplates: false,

            toolbar: [
                [{'header': [false, 1, 2, 3, 4, 5, 6]}],
                ['bold', 'italic', 'underline', 'strike'],
                [{'header': 1}, {'header': 2}],
                ['blockquote', 'code-block'],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'color': []}, {'background': []}],
            ],

            loadingSubmitApartmentRules: false,
        }
    },
    methods: {
        async toggleDialog(open) {
            if (this.rule_templates.length===0) {
                await this.fetchRuleTemplates();
            }
            this.rulesTemplateDialog = open;
        },
        async fetchRuleTemplates() {
            this.loadingFetchRuleTemplates = true;
            await axios.get('/api/rules')
                .then(res => {
                    this.rule_templates = res.data.rule_templates;
                })
                .catch(err => {
                    console.error(err);
                });
            this.loadingFetchRuleTemplates = false;
        },

        useSelectedItem() {
            let items = ``;
            this.selectedRuleItems.forEach(item => {
                items += `<ul><li>${item}</li></ul>`;
            });
            this.apartment.rules += items;
            this.$emit('updateApartment', this.apartment);
            this.selectedRuleItems = [];
            this.rulesTemplateDialog = false;
        },

        async submitApartmentRules() {
            this.loadingSubmitApartmentRules = true;
            await axios
                .post(`/api/apartments/${this.apartment._id}/update_rules`, {
                    rules: this.apartment.rules,
                    supportRequest_id: this.supportRequest_id
                })
                .then(async () => {
                    this.$emit('updateApartment', this.apartment);
                    await createSupportRequest(this.supportRequest_id, {
                        text: 'ویرایش مجموعه در مرحله ثبت قوانین مجموعه'
                    });
                    let message = `قوانین مجموعه ثبت شد`;
                    this.$snackbar.showMessage({content: message, color: 'success'});
                    this.goToStep(this.step + 1);
                })
                .catch(err => {
                    console.error(err);
                });
            this.loadingSubmitApartmentRules = false;
        },
        created(){
            this.apartment.rules = '';
        }
    }
}
</script>

<style scoped>

</style>